module.exports = __webpack_public_path__ + "assets/Cannerald_Shop_Icon-T-Shirt.dd7da7dd.svg";